'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexRegionStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /** Container will occupy all available space */
  spread: _propTypes2.default.bool,

  /** Set content flow direction */
  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical'])
};
var defaultProps = {
  spread: false,
  layoutDirection: 'vertical'
};
/** PROP RECEIVERS */

var contentFlow = function contentFlow(_ref) {
  var layoutDirection = _ref.layoutDirection;
  var flexDirection = layoutDirection === 'horizontal' ? 'row' : 'column';
  return '\n    flex-direction: ' + flexDirection + ';\n  ';
};

var spread = function spread(_ref2) {
  var spread = _ref2.spread;
  return spread && 'flex-grow: 1;';
};

var base = function base(_ref3) {
  var themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
};
/** STYLES */


var FlexRegionStyled = exports.FlexRegionStyled = _styledComponents2.default.div.withConfig({
  displayName: 'FlexRegionStyled'
})(['width:auto;display:flex;', ' ', ' ', ';'], base, spread, contentFlow);

FlexRegionStyled.propTypes = propTypes;
FlexRegionStyled.defaultProps = defaultProps;
FlexRegionStyled.displayName = 'FlexRegionStyled';